const pagesContractorCoreOperationPackagesEn = {
  contractorCore: "Contractor Core",
  startNew: "Start new",
  tabs: {
    operationPackages: "Operation packages",
    archive: "Archive",
    config: "Config",
  },
  patternEmptyState: {
    title: "No operation package pattern",
    description:
      "No operation package pattern found. Please register from the Add pattern button above.",
  },
  status: {
    todo: "Todo",
    completed: "Completed",
    attachment: "Attachment",
    approval: "Approval",
    approvalRequired: "Approval Required",
    notRequired: "Not Required",
  },
  displayDataAggregate: "Display: Data aggregate",
  sideTab: {
    close: "Close side tab",
    demoItems: {
      entryProcedure: "Entry Procedure",
      contractSigning: "Contract Signing & E-signature",
      creditCheck: "Credit Check",
      contractTerms: "Contract Terms Management",
      contractRenewal: "Contract Renewal & Period Management",
      payment: "Payment Management",
      workDelivery: "Work & Delivery Management",
      documentManagement: "Document Management (PO/Invoice/Payment)",
      personnelEvaluation: "Personnel Evaluation",
    },
    underDevelopment: "This operation package is currently under development.",
  },
  demo: {
    title: "Business contract partner core is currently under development.",
    description:
      "This screen is a preview of the development. The actual function will be released in the future.",
    patternType: {
      freelancer: "Freelancer",
      employee: "Employee",
      outsource: "Outsource",
      cooperativeCompanyMember: "Cooperative Company Member",
    },
  },
  addPattern: {
    addButtonLabel: "Add operation package pattern",
    success: "Operation package pattern created successfully",
    error: "Failed to create operation package pattern",
  },
  taskEmptyState: {
    title: "No Operation task",
    description:
      "No operation task found. Please register from the Add operation task button above.",
  },
  assignTaskToPerson: {
    selectPackage: "Select operation package",
    selectPackageDescription: "Select the operation package to assign",
    selectPackagePattern: "Select operation package pattern",
    selectPackagePatternDescription:
      "Select the operation package pattern to assign",
    selectPerson: "Select target",
    selectPersonDescription: "Select the target to assign",
    startOperationTask: "Start operation task",
    startOperationTaskDescription:
      "Start the operation task by selecting the operation package and pattern, and then assigning the target.",
    selectedOperationPackage: "Selected operation package",
    selectedOperationPattern: "Selected operation package pattern",
    selectPersonPlaceholder: "Select target",
    selectedPerson: "Selected target",
    anchorDate: "Anchor date",
    assignSuccess: "Operation task assigned successfully",
    assignSuccessMessage: "{{count}} operation tasks assigned",
    addPersonDialog: {
      title: "Create new",
      description: "Create a new person",
    },
  },
};

export default pagesContractorCoreOperationPackagesEn;
